// extracted by mini-css-extract-plugin
module.exports = {"fees-summary":"fees-summary___hypo","annual-Fee-details":"annual-Fee-details___hypo"};